__turbopack_context__.v({
  "input__inlinebutton": "NewsletterSignup-module-scss-module__yEo3FW__input__inlinebutton",
  "newsletter": "NewsletterSignup-module-scss-module__yEo3FW__newsletter",
  "newsletter__input": "NewsletterSignup-module-scss-module__yEo3FW__newsletter__input",
  "newsletter_label": "NewsletterSignup-module-scss-module__yEo3FW__newsletter_label",
});
